import type { JSX } from 'react';
import type { WireSourceHealthRow } from '@logistics/contracts';
import { ago, millis } from '@/lib/format';
import { sourceGlyph, sourceKindName } from '@/lib/glyphs';
import { glyphTile } from '../shell/look';
import { latencyWidth, statusLook } from './status';
import { StatusDot } from './status-dot';

export const HEALTH_COLUMNS =
  'grid grid-cols-[34px_minmax(0,1.4fr)_minmax(0,2fr)_80px_100px_110px] items-center gap-3.5 px-5';

/** One source in the health table (design L528–535). */
export function HealthRow({ row }: { row: WireSourceHealthRow }): JSX.Element {
  const { color } = statusLook(row.status);
  return (
    <div className={`${HEALTH_COLUMNS} border-line border-b py-3.5 last:border-b-0`}>
      <span className={glyphTile}>{sourceGlyph(row.kind)}</span>
      <div className="min-w-0">
        <div className="truncate text-sm font-medium">{row.label}</div>
        <div className="text-mute text-xs">{sourceKindName(row.kind)}</div>
      </div>
      <div
        className="bg-surf2 h-1.5 overflow-hidden rounded-[3px]"
        title={row.latencyMs === undefined ? 'No calls in 24 h' : `Latest ${millis(row.latencyMs)}`}
      >
        <div
          className="h-full rounded-[3px] transition-[width] duration-600 ease-in-out"
          style={{ width: latencyWidth(row.latencyMs), background: color }}
        />
      </div>
      <span className="font-mono text-xs">{millis(row.p95Ms)}</span>
      <span className="text-mute font-mono text-xs">
        {row.lastSyncAt === undefined ? 'never' : ago(row.lastSyncAt)}
      </span>
      <StatusDot status={row.status} className="justify-end" />
    </div>
  );
}
